//TestimonialsPage.jsx


import React, { useRef } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import {
  Quote,
  GraduationCap,
  BookOpen,
  Award,
  Users,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import axios from "axios";
import ENDPOINT from "../../src/data/ENDPOINT";
import SecurityHeaders from "../../src/data/SecurityHeaders";
import { useState, useEffect } from "react";

const TestimonialsPage = () => {
  const scrollRef = useRef(null);

  const [testimonials, setTestimonials] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const data = new FormData();
        data.append("limit", 10); // you can adjust
  
        const res = await axios.post(
          ENDPOINT + "get-reviews.php",
          data,
          SecurityHeaders
        );
  
        if (res.data.status === "success") {
          setTestimonials(res.data.data);
        }
      } catch (error) {
        console.log("Error fetching reviews", error);
      }
    };
  
    fetchReviews();
  }, []);

  // const testimonials = [
  //   {
  //     name: "Adam Riky",
  //     role: "Full Stack Developer",
  //     content:
  //       "The curriculum is perfectly structured. I went from knowing basic HTML to building full-scale applications in months. Highly recommend!",
  //     image:
  //       "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop",
  //   },
  //   {
  //     name: "Roy Cardona",
  //     role: "Product Designer",
  //     content:
  //       "This platform changed my perspective on online learning. The mentors are top-tier and the community is incredibly supportive.",
  //     image:
  //       "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop",
  //   },
  //   {
  //     name: "Robert Fox",
  //     role: "LinkedIn Leader",
  //     content:
  //       "A game-changer for my career growth. The interactive courses helped me master concepts that used to be confusing.",
  //     image:
  //       "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop",
  //   },
  //   {
  //     name: "Sarah Jenkins",
  //     role: "UI/UX Researcher",
  //     content:
  //       "I loved the practical approach. Every lesson was followed by a hands-on project that I could actually add to my portfolio.",
  //     image:
  //       "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
  //   },
  //   {
  //     name: "Michael Chen",
  //     role: "Data Analyst",
  //     content:
  //       "The best investment I've made for my career. The complex data science concepts were broken down into very manageable modules.",
  //     image:
  //       "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop",
  //   },
  // ];

  const stats = [
    { label: "Active Students", value: "1,250+", icon: <Users size={20} />, bg: "#ecfdf5", color: "#10b981" },
    { label: "Interactive Courses", value: "60+", icon: <BookOpen size={20} />, bg: "#eff6ff", color: "#3b82f6" },
    { label: "Graduate Students", value: "3,210+", icon: <GraduationCap size={20} />, bg: "#fffbeb", color: "#f59e0b" },
    { label: "Certified Teachers", value: "30+", icon: <Award size={20} />, bg: "#faf5ff", color: "#8b5cf6" },
  ];

  const scroll = (dir) => {
    const el = scrollRef.current;
    if (!el) return;
    const amount = el.clientWidth * 0.9;
    el.scrollBy({ left: dir === "left" ? -amount : amount, behavior: "smooth" });
  };

  return (
    <div style={{ overflowX: "hidden" }}>
      <Container className="py-3">
        {/* Header */}
        <div className="text-center mb-4">
          <div style={{ color: "#10b981", fontWeight: 600, letterSpacing: 1, fontSize: 12 }}>
            TESTIMONIALS
          </div>
          <h2 style={{ fontWeight: 800, fontSize: "clamp(22px,3vw,38px)" }}>
            What Did Our Students Say About Us?
          </h2>
          <p className=" mx-auto" style={{ maxWidth: 700, fontSize: 14,color: "#121212" }}>
            Discover how our platform has helped thousands of students achieve their career goals.
          </p>
        </div>

        {/* Slider */}
        <div className="position-relative mb-5">
          <Button
            onClick={() => scroll("left")}
            className="position-absolute top-50 start-0 translate-middle-y rounded-circle shadow px-2 py-2 d-flex align-items-center justify-content-center"
            style={{ zIndex: 5, background: "#fff", border: "1px solid #eee", color: "#555" }}
          >
            <ChevronLeft size={18} />
          </Button>

          <Button
            onClick={() => scroll("right")}
            className="position-absolute top-50 end-0 translate-middle-y rounded-circle shadow px-2 py-2 d-flex align-items-center justify-content-center" 
            style={{ zIndex: 5, background: "#fff", border: "1px solid #eee", color: "#555" }}
          >
            <ChevronRight size={18} />
          </Button>

          <div ref={scrollRef} className="d-flex gap-3 testimonial-scroll pb-3">
          {testimonials.length > 0 ? (
  testimonials.map((item, i) => (
              <div key={i} className="bg-white border rounded-4 p-3 testimonial-card d-flex flex-column justify-content-between">
                <div>
                  <Quote size={26} style={{ color: "#d1fae5" }} />
                  <p
  className="fst-italic mt-2"
  style={{
    fontSize: 14,
    lineHeight: 1.6,
    color: "#121111",
    display: "-webkit-box",
    WebkitLineClamp: expandedIndex === i ? "unset" : 4,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  }}
>
  "{item.review}"
</p>

{item.review && item.review.length > 150 && (
  <span
    onClick={() =>
      setExpandedIndex(expandedIndex === i ? null : i)
    }
    style={{
      color: "#10b981",
      cursor: "pointer",
      fontSize: "13px",
      fontWeight: 500,
    }}
  >
    {expandedIndex === i ? "Show Less" : "Read More"}
  </span>
)}
                </div>

               <div className="d-flex align-items-center gap-2 border-top pt-2 mt-2">
                  <div
                    style={{
                      width: 46,
                      height: 46,
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: "2px solid #d1fae5",
                    }}
                  >
                    <img
                      src={`https://admin.siliconmindstechnologies.com/${item.profile_pic}`}
                      alt={item.name}
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      onError={(e) => {
                        e.target.src = `https://ui-avatars.com/api/?name=${item.name}`;
                      }}
                    />
                  </div>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>{item.name}</div>
                    <div style={{ color: "#10b981", fontSize: 12 }}>{item.email}</div>
                  </div>
                </div>
              </div>
            ))) : (
              <div className="d-flex align-items-center justify-content-center" style={{ height: 200, width: "100%" }}>
                <p style={{ color: "#555", fontSize: 14 }}>No testimonials available at the moment.</p>
              </div>
            )} 
          </div>
        </div>

        {/* Stats */}
        {/* <div className="bg-white rounded-4 p-4 p-md-5 border">
          <Row className="g-4">
            {stats.map((s, i) => (
              <Col key={i} xs={6} lg={3}>
                <div className="d-flex align-items-center gap-3">
                  <div
                    style={{
                      background: s.bg,
                      color: s.color,
                      padding: 14,
                      borderRadius: 14,
                    }}
                  >
                    {s.icon}
                  </div>
                  <div>
                    <div style={{ fontSize: 22, fontWeight: 800 }}>{s.value}</div>
                    <div className="text-muted" style={{ fontSize: 12 }}>
                      {s.label}
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div> */}
      </Container>

      {/* Internal CSS */}
      <style>{`
        .testimonial-scroll {
          overflow-x: auto;
          scroll-snap-type: x mandatory;
        }

        .testimonial-scroll {
  align-items: flex-start !important;
}

        .testimonial-card {
          min-width: 100%;
          scroll-snap-align: center;
        }

        @media (min-width: 768px) {
          .testimonial-card {
            min-width: 48%;
          }
        }

        @media (min-width: 1200px) {
          .testimonial-card {
            min-width: 32%;
          }
        }

        .testimonial-scroll::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default TestimonialsPage;
